$(document).on('ready turbolinks:load', () => {
  $('form.edit_line input').off('change').on('change', ({ currentTarget }) => {
    $(currentTarget).parents('form').submit();
  });
  $('.page.page-lines .row-link td:not(.not-a-link)').off('click').on('click', ({ currentTarget }) => {
    window.open($(currentTarget).parent().data('href'), '_blank');
  });
});
